"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _styling = require("../../../toolkit/styling");

var icons = _interopRequireWildcard(require("../../../toolkit/icons"));

var _providers = require("../../../toolkit/providers");

//
//  SideProgressItem.tsx
//  Project-Lego
//
//  Created by Jack Zhu on 4/15/2020
//  Copyright © 2020-present ContextLogic Inc. All rights reserved.
//

/* Lego Toolkit */
var SideProgressItem = function SideProgressItem(props) {
  var hasCompleted = props.hasCompleted,
      selected = props.selected,
      className = props.className,
      children = props.children;
  var styles = useStyleSheet(hasCompleted);
  var iconUrl = getIcon(hasCompleted);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.root, selected && styles.selected, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.icon, className)
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: iconUrl,
    className: (0, _styling.css)(styles.icon),
    draggable: "false"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.textContainer)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.descriptionText)
  }, " ", children, " ")));
};

var _default = SideProgressItem;
exports["default"] = _default;

var getIcon = function getIcon(hasCompleted) {
  return hasCompleted ? icons.cyanCheckmark : icons.emptySelection;
};

var useStyleSheet = function useStyleSheet(hasCompleted) {
  var _useTheming = (0, _providers.useTheming)(),
      _useTheming$theme = _useTheming.theme,
      textUltraLighter = _useTheming$theme.textUltraLighter,
      textBlack = _useTheming$theme.textBlack,
      surfaceLightest = _useTheming$theme.surfaceLightest,
      surfaceLight = _useTheming$theme.surfaceLight,
      fonts = _useTheming.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        borderRadius: 4,
        overflow: "hidden",
        alignItems: "center",
        backgroundColor: surfaceLightest,
        display: "flex",
        flexDirection: "row",
        padding: "20px 25px"
      },
      textContainer: {
        display: "flex",
        alignItems: "flex-start",
        flexDirection: "column",
        justifyContent: "center"
      },
      descriptionText: {
        color: textBlack,
        fontFamily: fonts.medium,
        textDecoration: hasCompleted ? "line-through" : "none",
        opacity: hasCompleted ? 0.5 : 1
      },
      icon: {
        width: 28,
        height: 28,
        marginRight: 16,
        alignSelf: "flex-start"
      },
      selected: {
        color: textUltraLighter,
        backgroundColor: surfaceLight
      }
    });
  }, [fonts.medium, hasCompleted, textUltraLighter, surfaceLightest, surfaceLight, textBlack]);
};